import { ConfirmationModal } from 'views/components';
import { configActions } from 'core/Config';
import { useTranslation } from 'react-i18next';
import {
    CompoundButton,
    Table
} from 'mol-ui';
import {
    ConfigNotificationModal,
    ConfigTemplateModal
} from './components';
import {
    Container,
    Title
} from './styled';
import {
    NOTIFICATIONS,
    TEMPLATES
} from './fixtures';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const NotificationConfiguration = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        notifications,
        notificationsLoading,
        templates,
        templatesLoading
    } = useSelector('config');
    const [deleteModal, setDeleteModal] = useState(null);
    const [editModal, setEditModal] = useState(null);

    useEffect(() => {
        dispatch(configActions.getConfigTemplates());
        dispatch(configActions.getConfigNotifications());
    }, []);

    const actionController = modal => [{
        icon: 'edit',
        onClick: row => setEditModal({ ...row, modal }),
        title: t('Editar')
    }, {
        icon: 'delete',
        onClick: row => setDeleteModal({ ...row, modal }),
        title: t('Eliminar')
    }];

    const deleteModalHandler = result => {
        setDeleteModal(null);
        if (result === 'cancel') return;
        const { id, modal } = deleteModal;
        dispatch(modal === 'notification' ? configActions.deleteNotification(id) : configActions.deleteTemplate(id));
    };

    return (
        <Container>
            <Title>{ t('Notificaciones') }</Title>
            <Table
                config={ NOTIFICATIONS }
                data={ notifications }
                loading={ notificationsLoading }
                margin="10px 0px"
                maxHeight="500px"
                rowActions={ actionController('notification') }
            />
            <CompoundButton
                caption={ t('Agregar nueva notificación') }
                fontSize="12px"
                icon="add"
                margin="0px 0px 20px 0px"
                size={ 20 }
                onClick={ () => setEditModal({ modal: 'notification' }) }
            />
            <Title>{ t('Templates') }</Title>
            <Table
                config={ TEMPLATES }
                data={ templates }
                loading={ templatesLoading }
                margin="10px 0px"
                maxHeight="500px"
                rowActions={ actionController('template') }
            />
            <CompoundButton
                caption={ t('Agregar nuevo template') }
                fontSize="12px"
                icon="add"
                margin="0px 0px 20px 0px"
                size={ 20 }
                onClick={ () => setEditModal({ modal: 'template' }) }
            />
            <ConfigNotificationModal
                active={ editModal?.modal === 'notification' }
                data={ editModal }
                onToggle={ () => setEditModal(null) }
            />
            <ConfirmationModal
                actionHandler={ deleteModalHandler }
                active={ deleteModal?.modal === 'notification' }
                confirmText={ t('Eliminar') }
                title={ t('Desea eliminar la notificación seleccionada?') }
            />
            <ConfigTemplateModal
                active={ editModal?.modal === 'template' }
                data={ editModal }
                onToggle={ () => setEditModal(null) }
            />
            <ConfirmationModal
                actionHandler={ deleteModalHandler }
                active={ deleteModal?.modal === 'template' }
                confirmText={ t('Eliminar') }
                title={ t('Desea eliminar el template seleccionado?') }
            />
        </Container>
    );
};

export default NotificationConfiguration;
